import { api } from "../api";

/**
 * departmentFindAllCrudResponse - Function that finds on database all departments by customer and secretary as crud response data   
 * /departments/{customerId}/{secretaryId}/{status}  
 * method GET 
 * @async-function
 */
const departmentFindAllCrudResponse = async (token: string, customerId: number, secretaryId: number,status: string, page: number, size: number) => {
    const response = await api.get(
        `/departments/${customerId}/${secretaryId}/${status}?page=${page}&size=${size}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default departmentFindAllCrudResponse;